import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';

/**
 * Custom hook for handling URL-based photo selection
 * @param {Function} setSelectedPhoto - Function to set the selected photo
 * @returns {Object} Photo selection functions
 */
const useUrlPhotoSelection = setSelectedPhoto => {
  const $ = _c(4);
  let t0;
  if ($[0] !== setSelectedPhoto) {
    t0 = photos => {
      if (typeof window !== "undefined") {
        const urlParams = new URLSearchParams(window.location.search);
        const photoid = urlParams.get("photoid");
        if (photoid) {
          const photoToOpen = photos.find(photo => photo.photo_id === photoid);
          if (photoToOpen) {
            setSelectedPhoto(photoToOpen);
          }
        }
      }
    };
    $[0] = setSelectedPhoto;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handlePhotosLoaded = t0;
  let t1;
  if ($[2] !== handlePhotosLoaded) {
    t1 = {
      handlePhotosLoaded
    };
    $[2] = handlePhotosLoaded;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default useUrlPhotoSelection;